
import React, { useEffect } from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { isBrowser } from "@/utils/runtime";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

const TermsOfService = () => {
  // Set page title and meta tags for SEO
  useEffect(() => {
    if (!isBrowser) return;
    globalThis.document.title = "Termos de Serviço | Toc Toc IA";

    // Add meta description dynamically
    const metaDescription = globalThis.document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute("content",
        "Termos de serviço do Toc Toc IA. Conheça as condições de uso da nossa plataforma de edição de imagens para corretores imobiliários antes de utilizar nossos serviços.");
    }

    // Set canonical URL
    let canonicalLink = globalThis.document.querySelector('link[rel="canonical"]');
    if (!canonicalLink) {
      canonicalLink = globalThis.document.createElement('link');
      canonicalLink.setAttribute('rel', 'canonical');
      globalThis.document.head.appendChild(canonicalLink);
    }
    canonicalLink.setAttribute('href', 'https://toctoc.com.br/terms-of-service');
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1 container max-w-4xl mx-auto px-4 py-12">
        <div className="mb-8">
          <Button variant="ghost" asChild className="text-toctoc-blue mb-4">
            <Link to="/">
              <ArrowLeft className="mr-2 h-4 w-4" />
              Voltar para Home
            </Link>
          </Button>
          <h1 className="text-3xl font-bold mb-6 text-toctoc-black">Termos de Serviço</h1>
        </div>

        <div className="prose max-w-none">
          <h2 className="text-xl font-semibold mb-4 text-toctoc-black">1. Aceitação dos Termos</h2>
          <p className="mb-4 text-toctoc-gray-dark">
            Ao acessar ou usar o serviço Toc Flash, você concorda em cumprir estes Termos de Serviço. Se você não concordar com alguma parte destes termos, não poderá acessar ou usar nosso serviço.
          </p>

          <h2 className="text-xl font-semibold mb-4 mt-8 text-toctoc-black">2. Alterações nos Termos</h2>
          <p className="mb-4 text-toctoc-gray-dark">
            Reservamo-nos o direito de modificar ou substituir estes Termos a qualquer momento. As alterações entrarão em vigor imediatamente após serem publicadas em nosso site. É sua responsabilidade verificar periodicamente se houve alterações.
          </p>

          <h2 className="text-xl font-semibold mb-4 mt-8 text-toctoc-black">3. Privacidade</h2>
          <p className="mb-4 text-toctoc-gray-dark">
            Nossa Política de Privacidade explica como coletamos, usamos e compartilhamos suas informações pessoais. Ao usar nossos serviços, você concorda com a coleta e uso de informações de acordo com nossa política de privacidade.
          </p>

          <h2 className="text-xl font-semibold mb-4 mt-8 text-toctoc-black">4. Licenças e Restrições</h2>
          <p className="mb-4 text-toctoc-gray-dark">
            O Toc Flash concede a você uma licença limitada, não exclusiva, não transferível e revogável para usar o serviço de acordo com estes Termos. Você não pode:
          </p>
          <ul className="list-disc pl-8 mb-4 text-toctoc-gray-dark">
            <li>Copiar, modificar ou criar trabalhos derivados do serviço</li>
            <li>Usar o serviço para qualquer finalidade ilegal</li>
            <li>Tentar acessar áreas restritas do serviço</li>
            <li>Interferir na segurança ou funcionamento do serviço</li>
          </ul>

          <h2 className="text-xl font-semibold mb-4 mt-8 text-toctoc-black">5. Rescisão</h2>
          <p className="mb-6 text-toctoc-gray-dark">
            Podemos encerrar ou suspender seu acesso ao serviço imediatamente, sem aviso prévio, por qualquer motivo, incluindo, mas não se limitando a, violação dos Termos. Todas as disposições destes Termos, que por sua natureza devem sobreviver ao término, sobreviverão ao término.
          </p>

          <div className="border-t border-gray-200 pt-8 mt-8">
            <p className="text-toctoc-gray">Última atualização: 10 de maio de 2025</p>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default TermsOfService;
